import React from "react";
import { Switch } from "antd";
import TransferModal from "../../../components/transactions/TransferModal";

const BikerControls = ({
    isAvailable,
    handleAvailabilityToggle,
    onTransferComplete,
    loading,
    walletBalance,
}) => {
    return (
        <div className="flex justify-between items-center mb-10 px-4 flex-wrap gap-4">
            {/* Driver Withdrawal */}
            <div className="flex space-x-4">
                <TransferModal
                    initialType="bank"
                    isBusiness={true}
                    onComplete={onTransferComplete}
                    walletBalance={walletBalance}
                >
                    <button
                        className="bg_side_green rounded-full px-8 py-2 text-white font-medium hover:bg-green-700 transition"
                        style={{ width: "fit-content" }}
                    >
                        Withdraw to Bank
                    </button>
                </TransferModal>
            </div>

            {/* Availability Toggle */}
            <div className="flex items-center gap-4 bg-white p-3 rounded-xl shadow-sm border px-6">
                <div className="text-right">
                    <div className="text-sm font-bold text-gray-900">
                        {isAvailable ? "Online" : "Offline"}
                    </div>
                    <div className={`text-[10px] uppercase font-bold ${isAvailable ? "text-green-600" : "text-red-600"}`}>
                        {isAvailable ? "Available" : "Unavailable"}
                    </div>
                </div>
                <Switch
                    checked={isAvailable}
                    onChange={handleAvailabilityToggle}
                    disabled={loading}
                    className={isAvailable ? "bg-[#258635]" : "bg-[grey]"}
                />
            </div>
        </div>
    );
};

export default BikerControls;
